export const DetalleFields = {
    Id: 'id',
    IdOperacion: 'idOperacion',
    DescripcionOperacionTipo: 'descripcionOperacionTipo',
    DescripcionOperacionExcepcion: 'descripcionOperacionInstrumentoExcepcion',
    DescripcionExcepcion: 'operacionExcepcion'
} as const

export const DetallePutFields = {
    CodOperacionTipo: 'codOperacionTipo',
    CodOperacionExcepcion: 'codOperacionInstrumentoExcepcion',
    Excepcion: 'operacionExcepcion'
} as const
